import { render, staticRenderFns } from "./ItemLain.vue?vue&type=template&id=a58a098c&scoped=true&"
import script from "./ItemLain.vue?vue&type=script&lang=js&"
export * from "./ItemLain.vue?vue&type=script&lang=js&"
import style0 from "./ItemLain.vue?vue&type=style&index=0&id=a58a098c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a58a098c",
  null
  
)

export default component.exports